import React from 'react';

import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';

import styles from './chatMessagesStyles.scss';

const SystemChatMessage: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => {
  return (
    <div className={styles.chatMessage}>
      <div className={styles.chatMessageUser}>
        <ProfileImage source="/images/homepage/logo_symbol.png" />
        <div>
          <p>
            <strong>SumZero System</strong>
          </p>
        </div>
      </div>
      <div className={styles.chatMessageBody}>{children}</div>
    </div>
  );
};

export default SystemChatMessage;
